import { Component, Input, OnInit } from '@angular/core';
import { Morphbox } from '@models/Sessions/Morphbox/Morphbox';
import { Session } from '@models/Sessions/Session';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusService } from '@services/bus.service';
import { ConfigService, IInputLengths } from '@services/config.service';
import { EventsService } from '@services/events.service';
import { SessionMorphboxRequestService } from '@services/sessions/session.morphbox.request.service';

@Component({
  selector: 'app-morphbox-new-element-modal',
  templateUrl: './new-element-modal.component.html',
  styleUrls: ['./new-element-modal.component.scss'],
})
export class NewMorphboxElementModalComponent implements OnInit {
  @Input() morphbox: Morphbox;
  @Input() session: Session;
  @Input() row: any;

  element = {
    text: '',
  };

  loading = false;

  inputLengths: IInputLengths;

  constructor(
    public activeModal: NgbActiveModal,
    private appConfig: ConfigService,
    private bus: BusService,
    private events: EventsService,
    private morphboxRequest: SessionMorphboxRequestService,
  ) {
    this.inputLengths = appConfig.inputLengths;
  }

  close() {
    this.loading = true;
    this.bus.publish(
      this.events.requested.action.session.morphbox.addElement,
      this.element,
      this.row,
      this.morphbox,
      this.session,
    );
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  addElementSuccess() {
    this.activeModal.close();
  }

  addElementFailure() {
    this.activeModal.dismiss();
  }

  ngOnInit() {
    this.bus.subscribe(
      this.events.received.action.session.morphbox.addElement.success,
      this.addElementSuccess.bind(this),
    );
    this.bus.subscribe(
      this.events.received.action.session.morphbox.addElement.failure,
      this.addElementFailure.bind(this),
    );
  }
}
